import { useQuery } from 'react-query';

import { Chronology } from '../types/backend-dto-types';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetChronology = ({ chronologyId, caseId }: { chronologyId: string; caseId: string }) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<Chronology>([QueryEntity.Chronology, { chronologyId }], () => {
    return fetch(`${APIBaseChronos}/api/case/${caseId}/chronology/${chronologyId}`, fetchConfigGET).then((res) => {
      return res.json();
    });
  });
};
